import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class BaseModel extends BaseEntity {

    versao: number;

    constructor(id?: number, versao?: number) {
        super();
        this.id = id;
        this.versao = versao;
    }
}
